import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Events from "@/pages/events/page";
import CategoryEvents from "@/pages/category/page";
import EventDetail from "@/pages/event/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/newsDetail/page";
import Schedule from "@/pages/schedule/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "events", element: <Events /> },
      { path: "category/:categoryId", element: <CategoryEvents /> },
      { path: "event/:eventId", element: <EventDetail /> },
      { path: "news", element: <News /> },
      { path: "news/:newsId", element: <NewsDetail /> },
      { path: "schedule", element: <Schedule /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;